module.exports = __webpack_public_path__ + "static/media/5.b19f7bc6.png";